import { Box, InputAdornment, TextField, Typography } from "@mui/material";
import { PropLayout } from "../PropLayout";

export const PropTypeDisplay = ({ label, value, unit }) => {
  return (
    <TextField
      label={label}
      type="text"
      variant="filled"
      value={value}
      disabled
      InputProps={
        unit
          ? {
              endAdornment: (
                <InputAdornment position="end">{unit}</InputAdornment>
              ),
            }
          : undefined
      }
    />
  );
};
